function setAnimProgressBar(context, value) {
  context.commit('setAnimProgressBar', value);
}

function setAnimStatus(context, value) {
  context.commit('setAnimStatus', value);
}

function setAnimCurrentStep(context, value) {
  context.commit('setAnimCurrentStep', value);
}

export default {
  setAnimProgressBar,
  setAnimStatus,
  setAnimCurrentStep
};
